import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Booking from './pages/Booking';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Reviews from './pages/Reviews';
import Contact from './pages/Contact';
import ConsultantSignup from './pages/ConsultantSignup';
import BookingSuccess from './pages/BookingSuccess';
import ParentPortal from './pages/portals/ParentPortal';
import ConsultantPortal from './pages/portals/ConsultantPortal';
import OwnerPortal from './pages/portals/OwnerPortal';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import RequireAuth from './components/RequireAuth';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Public marketing site — wraps all public routes with the site Header + Footer.
// Portal routes are registered separately and do NOT use this layout.
function PublicLayout() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* ── Portal routes — full-screen, own sidebar layout, auth-gated ── */}
        <Route
          path="/portal/parent"
          element={<RequireAuth role="parent"><ParentPortal /></RequireAuth>}
        />
        <Route
          path="/portal/consultant"
          element={<RequireAuth role="consultant"><ConsultantPortal /></RequireAuth>}
        />
        <Route
          path="/portal/admin"
          element={<RequireAuth role="admin"><OwnerPortal /></RequireAuth>}
        />

        {/* ── Public marketing site ── */}
        <Route element={<PublicLayout />}>
          <Route path="/"                  element={<Home />} />
          <Route path="/services"          element={<Services />} />
          <Route path="/book"              element={<Booking />} />
          <Route path="/book/success"      element={<BookingSuccess />} />
          <Route path="/blog"              element={<Blog />} />
          <Route path="/blog/:slug"        element={<BlogPost />} />
          <Route path="/reviews"           element={<Reviews />} />
          <Route path="/contact"          element={<Contact />} />
          <Route path="/become-consultant" element={<ConsultantSignup />} />
          <Route path="/login"             element={<Login />} />
          <Route path="/signup"            element={<Signup />} />
          <Route path="/forgot-password"   element={<ForgotPassword />} />
          <Route path="*"                  element={<Home />} />
        </Route>
      </Routes>
    </Router>
  );
}
